module.exports = __webpack_public_path__ + "16.11d4e318.png";